<template>
  <footer class="app-footer">
    <span><a href="https://coreui.io">CoreUI</a> &copy; 2018 creativeLabs.</span>
    <span class="ml-auto"
      >Powered by <a href="https://coreui.io">CoreUI</a></span
    >
  </footer>
</template>
<script>
export default {
  name: "c-footer",
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue